import { render, staticRenderFns } from "./PgaOfferEvaluationExpectedRevenueDetails.vue?vue&type=template&id=de8a9206&scoped=true&"
import script from "./PgaOfferEvaluationExpectedRevenueDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationExpectedRevenueDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PgaOfferEvaluationExpectedRevenueDetails.vue?vue&type=style&index=0&id=de8a9206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8a9206",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VFadeTransition,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8a9206')) {
      api.createRecord('de8a9206', component.options)
    } else {
      api.reload('de8a9206', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationExpectedRevenueDetails.vue?vue&type=template&id=de8a9206&scoped=true&", function () {
      api.rerender('de8a9206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/details/sub-components/PgaOfferEvaluationExpectedRevenueDetails.vue"
export default component.exports